module.exports = __webpack_public_path__ + "img/item_KEC-logo-white.7ab4b504.svg";